import { useTableURLParams } from "src/hooks/useTableURLParams.ts";

type CasesTableParamsType = {
  onlyScored: boolean;
};

export const useCasesTableURLParams = () => {
  const params: CasesTableParamsType = {
    onlyScored: false,
  };
  const converters = { onlyScored: (value) => value === "true" };
  return useTableURLParams(params, converters);
};
